<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
#app {
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

/* Element UI 深色主题 - 全局弹窗和消息 */
.el-message-box {
  background-color: #2d2d2d !important;
  border: 1px solid #3d3d3d !important;
  
  .el-message-box__header {
    padding: 15px 15px 10px;
  }
  
  .el-message-box__title {
    color: #fff !important;
  }
  
  .el-message-box__headerbtn .el-message-box__close {
    color: #888 !important;
    
    &:hover {
      color: #fff !important;
    }
  }
  
  .el-message-box__content {
    color: #ccc !important;
    padding: 10px 15px;
  }
  
  .el-message-box__btns {
    padding: 5px 15px 15px;
    
    .el-button--default {
      background-color: #3d3d3d !important;
      border-color: #4d4d4d !important;
      color: #fff !important;
      
      &:hover {
        background-color: #4d4d4d !important;
        border-color: #5d5d5d !important;
      }
    }
    
    .el-button--primary {
      background-color: #8bff8b !important;
      border-color: #8bff8b !important;
      color: #1a1a1a !important;
      
      &:hover {
        background-color: #7aee7a !important;
        border-color: #7aee7a !important;
      }
    }
  }
}

.el-message {
  background-color: #2d2d2d !important;
  border-color: #3d3d3d !important;
  
  .el-message__content {
    color: #fff !important;
  }
  
  &.el-message--success {
    background-color: rgb(48, 48, 48) !important;
    // border-color: rgba(139, 255, 139, 0.6) !important;
    
    .el-message__content {
      color: #8bff8b !important;
    }
    
    .el-message__icon {
      color: #8bff8b !important;
    }
  }
  
  &.el-message--warning {
    background-color: rgba(255, 193, 7, 0.15) !important;
    border-color: rgba(255, 193, 7, 0.3) !important;
    
    .el-message__content {
      color: #ffc107 !important;
    }
    
    .el-message__icon {
      color: #ffc107 !important;
    }
  }
  
  &.el-message--error {
    background-color: rgba(255, 77, 79, 0.15) !important;
    border-color: rgba(255, 77, 79, 0.3) !important;
    
    .el-message__content {
      color: #ff4d4f !important;
    }
    
    .el-message__icon {
      color: #ff4d4f !important;
    }
  }
}
</style>
